import { formatNumberForInt } from '../format/FormatNumber';

export const formatThousand = (num: number) => {
  return `${formatNumberForInt(Math.floor(num / 10000))}`;
};
